import type { ReactNode } from 'react';
import classNames from 'classnames';

import IconButton from 'components/partials/button/icon-button';

import Icons from 'assets/icons';

import {
  MARK_PANEL_CLOSE_ARIA_LABEL,
  MARK_PANEL_TITLE,
  MARK_PANEL_WIDTH_CLASS,
} from '../mark-panel.constants';

import MarkEmblem from './mark-emblem';

export interface MarkPanelDrawerProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

const MarkPanelDrawer = ({
  title,
  onClose,
  children,
  footer,
}: MarkPanelDrawerProps) => (
  <aside
    aria-label={MARK_PANEL_TITLE}
    className={classNames(
      'flex h-full flex-col border-l border-navy-200 bg-white',
      MARK_PANEL_WIDTH_CLASS
    )}
  >
    <div className="flex items-center gap-2 border-b border-navy-100 px-5 py-3">
      <MarkEmblem className="size-6 shrink-0" />

      <span className="w-[200px] truncate text-lg font-bold text-navy-800">
        {title}
      </span>

      <IconButton
        variant="reserve-text"
        size="xs"
        icon={<Icons.Close aria-hidden="true" />}
        aria-label={MARK_PANEL_CLOSE_ARIA_LABEL}
        onClick={onClose}
        className="ml-auto"
      />
    </div>

    <div className="scrollbar-thin flex min-h-0 flex-1 flex-col gap-5 overflow-x-hidden overflow-y-auto px-5 py-3">
      {children}
    </div>

    {footer && (
      <div className="flex min-h-[84px] items-center border-t border-navy-200 px-5 py-4">
        {footer}
      </div>
    )}
  </aside>
);

export default MarkPanelDrawer;
